import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const Navigation = ({ hamburger }) => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const buttonRef = useRef();
  const menuRef = useRef();

  useEffect(() => {
    if (!open) return;
    function handleClickOutside(e) {
      if (
        buttonRef.current && buttonRef.current.contains(e.target)
      ) return;
      if (
        menuRef.current && menuRef.current.contains(e.target)
      ) return;
      setOpen(false);
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  useEffect(() => {
    if (open) {
      setMenuVisible(true);
    } else if (menuVisible) {
      const timeout = setTimeout(() => setMenuVisible(false), 250);
      return () => clearTimeout(timeout);
    }
  }, [open]);

  if (!user) return null;
  if (hamburger) {
    return (
      <button
        id="tour-back-dashboard"
        ref={buttonRef}
        aria-label="Back to Dashboard"
        title="Back to Dashboard"
        style={{
          position: 'fixed',
          top: 12,
          left: 'calc(var(--left-panel-width, 250px) + 20px)',
          background: 'rgba(30, 41, 59, 0.7)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: 10,
          fontSize: 28,
          cursor: 'pointer',
          padding: 8,
          margin: 0,
          zIndex: 2000,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          transition: 'all 0.2s',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={() => navigate('/dashboard')}
      >
        {/* Simple Back Arrow / Home Icon using CSS */}
        <span style={{
          display: 'block',
          width: 24,
          height: 24,
          position: 'relative'
        }}>
          <span style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            width: 20,
            height: 3,
            background: 'currentColor',
            borderRadius: 2,
            transform: 'translateY(-50%)'
          }} />
          <span style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            width: 12,
            height: 3,
            background: 'currentColor',
            borderRadius: 2,
            transform: 'translateY(-50%) rotate(-45deg)',
            transformOrigin: 'top left'
          }} />
          <span style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            width: 12,
            height: 3,
            background: 'currentColor',
            borderRadius: 2,
            transform: 'translateY(-50%) rotate(45deg)',
            transformOrigin: 'bottom left'
          }} />
        </span>
      </button>
    );
  }
  return (
    <nav className="main-nav" style={{
      width: "100vw",
      padding: "12px 24px",
      background: 'rgba(15, 23, 42, 0.8)',
      backdropFilter: 'blur(8px)',
      borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      boxSizing: "border-box",
      display: 'flex',
      alignItems: 'center',
      gap: '24px'
    }}>
      <Link to="/dashboard" style={{
        color: 'var(--text)',
        fontWeight: 600,
        fontSize: '1.8rem',
        marginRight: 'auto',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        textDecoration: 'none'
      }}>
        <img src="/images/StoryWeaverLogo.svg" alt="StoryWeaver Logo" style={{ height: '1.8rem', width: 'auto' }} />
        Story Weaver
      </Link>
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
              <Link to="/dashboard" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }}>Dashboard</Link>
              <Link to="/decks" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }}>My Decks</Link>
              <Link to="/profile" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }}>User profile</Link>
              {user.role === "admin" && (
                <Link to="/admin" style={{ color: 'var(--text-secondary)', transition: 'color 0.2s' }}>Admin</Link>
              )}
            </div>
      <button
        onClick={logout}
        style={{
          background: 'transparent',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          padding: '6px 16px',
          fontSize: '0.9rem',
          borderRadius: '8px'
        }}
      >
        Logout
      </button>
    </nav>
  );
};

export default Navigation; 